import AscHomeContainer from './containers/AscHomeContainer.vue'
import { role } from '@/utilities/userRoles'

const homeRouter = {
  icon: 'mdi-home',
  path: '/',
  name: 'Home',
  display: true,
  meta: {
    primaryNavigation: true,
    requiresRole: role.airlineUser,
    tooltip: 'Go home',
    breadcrumbs: [
      {
        text: 'Dashboard',
      },
    ],
  },
  component: AscHomeContainer,
  children: [],
}

export default homeRouter
